<template>
  <app-base-main v-loading="loading.content">
    <template #base-content>
      <div>
        <gj-breadcrumb :list="breadcrumbList" @backHandle="goBack"></gj-breadcrumb>
      </div>
      <div class="content-cell">
        <div class="header">
          <span v-if="addOpType">添加发货计划</span>
          <span v-if="editOpType">{{ type === 'one' ? '编辑发货计划' : '批量编辑发货计划' }}</span>
        </div>
        <template v-if="addOpType">
          <el-form ref="form" :model="form" :rules="formRule" label-width="100px" inline>
            <el-form-item label="店铺国家" prop="marketId">
              <gj-market-select v-model="form.marketId" @input-option="marketChange" width="220px"></gj-market-select>
            </el-form-item>
            <el-form-item label="发货时间" prop="shipTime">
              <gj-date-picker v-model="form.shipTime" width="220px"></gj-date-picker>
            </el-form-item>
            <el-form-item label="包装类型" prop="areCasesRequired">
              <gj-select v-model="form.areCasesRequired" :options="options.areCasesRequiredOptions"
                         width="220px"></gj-select>
            </el-form-item>
            <br>
            <el-form-item label="批次备注" prop="memo">
              <gj-input v-model="form.memo" maxlength="200" style="width: 550px">
              </gj-input>
            </el-form-item>
          </el-form>
        </template>
        <template v-if="addOpType || editOpType">
          <DeliveryPlanPoducts
              ref="productForm"
              :form="form"
              :batchEdit="batchEdit"
              :transportOptionList="transportOptionList"
              :op-type="opType"
              :transfer-order="transferOrder"
          ></DeliveryPlanPoducts>
        </template>
        <div style="text-align: center;margin-bottom: -17px;margin-top: 10px;">
          <gj-button @click="goBack">取消</gj-button>
          <gj-button v-if="addOpType && draftVisible" :loading="loading.saveAsDraft"
                     @click="saveOrAudit(true)">保存为草稿
          </gj-button>
          <gj-button :loading="loading.audit"
                     type="primary" @click="saveOrAudit(false)">确定
          </gj-button>
        </div>
      </div>
    </template>
  </app-base-main>
</template>

<script>
import {formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin} from "@/minxins";
import {areCasesRequiredOptions} from "../deliveryEnum";
import {OpEnum} from "@/utils/options";
import {
  postSaveDeliveryPlan,
  postAddDeliveryPlan,
  postShipPlanPatchEdit,
  postShipPlanCopyQuery,
  postShipPlanBatchEditQuery, getDeliveryPlanTransportOption, shipPlanback
} from '@/api/logistics'
import {isMeaningful} from "@/utils/common";
import {convertToDate, convertToFullDate} from "@/utils/date.util";
import {downloadAttFile} from "@/api/common";

import DeliveryPlanPoducts from './delivery-plan-products'
import {queryReviewSetting} from "@/api/purchase";

export default {
  name: "app-op-purchase-plan-add",
  components: {DeliveryPlanPoducts},
  mixins: [formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin],
  props: {
    opType: {
      type: Number,
      default: 0
    },
    rows: {
      required: false,
      default: () => {
        return [];
      }
    },
    type: {
      required: false,
      default: 'one'
    }
  },
  data() {
    return {
      timeStamp: null,
      data: {},
      options: {
        areCasesRequiredOptions
      },
      form: {
        id: null,
        countryCode: null,
        marketId: null,
        areCasesRequired: 0,
        shipTime: '',
        warehouseId: '',
        memo: '',
        items: []
      },
      formRule: {
        marketId: [{
          required: true,
          message: '请选择店铺国家',
          trigger: ['blur', 'change'],
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请选择店铺国家'))
            }
            callback()
          }
        }],
        areCasesRequired: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请选择包装类型'
        }]
      },
      OpEnum,
      loading: {
        content: false,
        saveAsDraft: false,
        audit: false,
        finishPick: false,
      },
      batchEdit: false,
      draftVisible: true,
      transferOrder: {},
      transportOptionList: {},
      breadcrumbList: []
    }
  },
  created() {
    this.breadcrumbList = [
      {name: '发货计划', handle: () => {this.goBack()}},
      {name: this.addOpType ? '添加' : this.type === 'one' ? '编辑' : '批量编辑', handle: () => {}}
    ]
    // 编辑
    if (this.editOpType) {
      if (this.rows.length > 0) {
        this.queryEditData(this.rows.map(item => item.id));
        let checkStr = this.rows[0].countryCode + this.rows[0].marketId;
        let find = this.rows.filter(item => (item.countryCode + item.marketId) !== checkStr);
        this.batchEdit = find.length > 0;
        if (this.batchEdit) {
          this.rows.forEach(item => {
            this.getTransportOption(item.countryCode)
          })
        }
      }
    }
    // 添加
    else if (this.addOpType) {
      //从dashboard进入
      if(this.$route.query.timeStamp!=this.timeStamp){
        this.timeStamp = this.$route.query.timeStamp;
        this.form.marketId = this.$route.query.routeKey;
        this.form.countryCode = this.$route.query.countryCode;
        shipPlanback(this.$route.query.routeValue).then(res=>{
          this.form.items = res;
        })
      }
      //不是从dashboard进入
      else {
        if (this.rows.length > 0) {
          this.queryCopyData(this.rows.map(item => item.id));
        }
      }

      this.queryReviewShow()
    }
  },
  computed: {},
  methods: {
    queryCopyData(idList) {
      this.loading.content = true
      postShipPlanCopyQuery({idList}).then(res => {
        this.form.items = res.itemList;
        this.form.items.forEach(item => {
          if (item.transportId) {
            item.transportId = item.transportId + '#' + item.transportPrescriptionId
          }
        })
        this.form.countryCode = res.countryCode;
        this.form.marketId = res.marketId;
        this.form.areCasesRequired = res.areCasesRequired ? 1 : 0;
      }).complete(() => this.loading.content = false)
    },
    queryReviewShow() {
      queryReviewSetting({name: 'SHIP_PLAN_REVIEW_SETTING'}).then(res => {
        this.draftVisible = res;
      })
    },
    // 获取物流方式枚举
    getTransportOption(countryCode) {
      if (!countryCode) return false;
      return getDeliveryPlanTransportOption({
        arrivalCountry: countryCode
      }).then(res => this.transportOptionList = Object.assign(this.transportOptionList, {[countryCode]: res}))
    },
    queryEditData(idList) {
      this.loading.content = true
      postShipPlanBatchEditQuery({idList}).then(res => {
        if (res && res.length) {
          this.form.items = this._.cloneDeep(res);
          this.form.items.forEach(item => {
            if (item.transportId && item.transportPrescriptionId) {
              item.transportId = item.transportId + '#' + item.transportPrescriptionId;
            }

          })
          this.form.countryCode = this.rows[0].countryCode;
          this.form.marketId = this.rows[0].marketId;
        }


      }).complete(() => this.loading.content = false)
    },
    // 切换店铺赋值国家
    marketChange(val) {
      if (val) {
        this.form.countryCode = val.countryCode;
        this.form.items = [];
      }
    },
    download(fileId) {
      downloadAttFile(fileId);
    },
    saveOrAudit(saveDraft) {
      if (this.formValidate()) {
        if (saveDraft) {   //  保存为草稿
          this.loading.saveAsDraft = true;
        } else {
          this.loading.audit = true;
        }
        Promise.resolve(this.mapToFormParams())
            .then((params) => {
              if (this.addOpType) {
                if (saveDraft) {
                  return postSaveDeliveryPlan(params);
                } else {
                  return postAddDeliveryPlan(params)
                }
              }
              if (this.editOpType) {
                return postShipPlanPatchEdit(params);
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                if (this.addOpType) {
                  this.$gjMessage.success(`操作成功!`);
                }
                if (this.editOpType) {
                  this.$gjMessage.success('操作成功!');
                }
                this.goBack('refresh');
              });
            })
            .complete(() => {
              if (saveDraft) {
                this.loading.saveAsDraft = false;
              } else {
                this.loading.audit = false;
              }
            });
      }
    },

    goBack(val) {
      this.$emit('goBack', val)
    },
    mapToFormParams() {
      if (this.addOpType) {
        return {
          memo: this.form.memo || ' ',
          countryCode: this.form.countryCode,
          marketId: this.form.marketId,
          areCasesRequired: this.form.areCasesRequired,
          shipTime: convertToDate(this.form.shipTime, 'yyyy-MM-dd'),
          shipPlanList: this.form.items.map(item => ({
            cartonSizeH: item.cartonSizeH,
            cartonSizeL: item.cartonSizeL,
            cartonSizeW: item.cartonSizeW,
            fnsku: item.fnsku,
            memo: item.memo,
            msku: item.msku,
            packageQuantity: item.packageQuantity,
            packageH: item.packageH,
            packageL: item.packageL,
            packageW: item.packageW,
            packageWeight: item.packageWeight,
            shipedPlanQuantity: item.shipedPlanQuantity,
            singleProductNetWeight: item.singleProductNetWeight,
            singleQuantity: item.singleQuantity,
            sku: item.sku,
            transportShow: item.transportId || null,
            transportId: item.transportId ? item.transportId.split('#')[0] : null,
            warehouseId: item.warehouseId,
            transportPrescriptionId: item.transportId ? item.transportId.split('#')[1] : null,
          }))
        }
      }
      if (this.editOpType) {
        let list = this._.cloneDeep(this.form.items);
        list.forEach(item => {
          let temp = item.transportId;
          item.transportShow = temp || null;
          item.transportId = temp ? temp.split('#')[0] : null
          item.transportPrescriptionId = temp ? temp.split('#')[1] : null
          item.areCasesRequired = Boolean(item.areCasesRequired)
        })
        return list;
      }
    },

    formValidate() {
      if (this.addOpType) {
        if (!this.$gjFormValidate()) {
          return false;
        }
      }
      return this.$refs['productForm'].formValidate();
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text{
  font-size: 12px;
  color: #999999;
}
.nav-tips {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  font-weight: 400;
}

.tips-to {
  color: #333333;
}

.content-cell {
  background: #fff;
  padding: 15px;
}

.header {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  font-weight: 600;
  padding-bottom: 15px;
}
.icon-back{
  font-size: 12px;
  cursor: pointer;
}
.icon-back:hover{
 color: #5d9bfc;
}
/deep/ .is-justify-space-between .operate-group{
  margin: 0;
}
/deep/ .el-form-item__error{
  position: absolute;
  left: 5px;
}
</style>

